<lib-authentication-setup></lib-authentication-setup>
<router-outlet></router-outlet>
